var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuildingBank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "building-bank"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6061 2.08085C11.8576 1.97305 12.1424 1.97305 12.3939 2.08085L19.3939 5.08085C19.9015 5.29841 20.1367 5.88629 19.9191 6.39392C19.7016 6.90155 19.1137 7.1367 18.6061 6.91915L12 4.08797L5.39392 6.91915C4.88629 7.1367 4.29841 6.90155 4.08085 6.39392C3.8633 5.88629 4.09845 5.29841 4.60608 5.08085L11.6061 2.08085ZM2 10C2 9.44772 2.44772 9 3 9H21C21.5523 9 22 9.44772 22 10C22 10.5523 21.5523 11 21 11V20C21.5523 20 22 20.4477 22 21C22 21.5523 21.5523 22 21 22H3C2.44772 22 2 21.5523 2 21C2 20.4477 2.44772 20 3 20V11C2.44772 11 2 10.5523 2 10ZM5 11V20H19V11H5ZM8 13C8.55228 13 9 13.4477 9 14V17C9 17.5523 8.55228 18 8 18C7.44772 18 7 17.5523 7 17V14C7 13.4477 7.44772 13 8 13ZM12 13C12.5523 13 13 13.4477 13 14V17C13 17.5523 12.5523 18 12 18C11.4477 18 11 17.5523 11 17V14C11 13.4477 11.4477 13 12 13ZM16 13C16.5523 13 17 13.4477 17 14V17C17 17.5523 16.5523 18 16 18C15.4477 18 15 17.5523 15 17V14C15 13.4477 15.4477 13 16 13Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildingBank);
export default __webpack_public_path__ + "static/media/building-bank.a66daa5028d79eef574de98ca5740280.svg";
export { ForwardRef as ReactComponent };